<script setup lang="ts">
import { defineVaDataTableColumns, VaButton, VaCard, VaCardContent, VaCardTitle } from 'vuestic-ui'
import { useHomeStore } from '../../../../stores/home'
import { parseISO, format } from 'date-fns'
import { useRouter } from 'vue-router'

const router = useRouter()
const homeStore: any = useHomeStore()

const columns = defineVaDataTableColumns([
  { label: 'Data', key: 'created_at', displayFormatFn: (value) => format(parseISO(value), "dd/MM/yyyy - HH'h'mm'm'") },
  { label: 'Comprador', key: 'buyer' },
  {
    label: 'Valor',
    key: 'total',
    displayFormatFn: (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value),
    tdClass: 'text-green-600 font-bold',
  },
])

async function handleClick(row: any) {
  await router.push({ name: 'sale', params: { id: row.item.id } })
}
</script>

<template>
  <VaCard>
    <VaCardTitle class="flex items-start justify-between">
      <h1 class="font-bold uppercase card-title text-secondary">Últimos Pedidos</h1>
      <VaButton preset="primary" size="small" to="/sales">Ver todas as vendas</VaButton>
    </VaCardTitle>
    <VaCardContent>
      <div v-if="homeStore.data.latest_orders.length > 0">
        <VaDataTable clickable hoverable :items="homeStore.data.latest_orders" :columns="columns"
          :loading="!homeStore.data.loaded" @row:click="handleClick">
          <template #cell(buyer)="{ rowData }">
            <div class="ellipsis max-w-[230px] lg:max-w-[450px]">
              <p v-if="rowData.customer_id">
                {{ rowData?.customer?.name }}
              </p>
              <p v-else-if="rowData.professional_id">
                {{ rowData?.professional?.name }}
              </p>
              <p v-else-if="rowData.tenant_id">
                {{ rowData?.tenant?.name }}
              </p>
            </div>
          </template>
          <!--          <template #cell(project_owner)="{ rowData }">-->
          <!--            <div class="flex items-center gap-2 ellipsis max-w-[230px]">-->
          <!--              <UserAvatar-->
          <!--                v-if="getUserById(rowData.project_owner)"-->
          <!--                :user="getUserById(rowData.project_owner)!"-->
          <!--                size="small"-->
          <!--              />-->
          <!--              {{ getUserById(rowData.project_owner)?.fullname }}-->
          <!--            </div>-->
          <!--          </template>-->
          <!--          <template #cell(team)="{ rowData: project }">-->
          <!--            <VaAvatarGroup size="small" :options="getTeamOptions(project.team)" :max="2" />-->
          <!--          </template>-->
          <!--          <template #cell(status)="{ rowData: project }">-->
          <!--            <ProjectStatusBadge :status="project.status" />-->
          <!--          </template>-->
        </VaDataTable>
      </div>
      <div v-else class="p-4 flex justify-center items-center text-[var(--va-secondary)]">Nenhum pedido</div>
    </VaCardContent>
  </VaCard>
</template>
